import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { useSearchParams } from 'react-router-dom';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClaimStatuses, tClaimStatus, BillingTypeCodes, BillingTypeCodeToTypeMapping } from '@models/InsuranceClaim';
import { FormGroupControl, FormGroupSelect } from '@components/Base';

export type FormValues = {
  startDate?: string;
  endDate?: string;
  status: ClaimStatuses | '';
  billingType?: string;
  search?: string;
};

const ClaimControlForm = () => {
  const { t } = useTranslation();
  const [, setSearchParams] = useSearchParams();
  const initialValues: FormValues = { startDate: '', endDate: '', status: '', billingType: '', search: '' };

  const handleSubmit = (values: FormValues) => {
    setSearchParams({ ...values });
  };

  return (
    <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit}>
      <Form>
        <Row className="align-items-end">
          <Col xs={2}>
            <FormGroupControl type="date" name="startDate" label={t('claim.startDate')} />
          </Col>

          <Col xs={2}>
            <FormGroupControl type="date" name="endDate" label={t('claim.endDate')} />
          </Col>

          <Col>
            <FormGroupSelect name="status" label={t('common:status')}>
              <option value="">{t('common:all')}</option>
              {map(ClaimStatuses, (value) => (
                <option key={value} value={value}>
                  {tClaimStatus(value)}
                </option>
              ))}
            </FormGroupSelect>
          </Col>

          <Col>
            <FormGroupSelect name="billingType" label={t('common:billingType')}>
              <option value="">{t('common:all')}</option>
              {map(BillingTypeCodes, (value) => (
                <option key={value} value={BillingTypeCodeToTypeMapping[value]}>
                  {value}
                </option>
              ))}
            </FormGroupSelect>
          </Col>

          <Col xs={4}>
            <FormGroupControl name="search" label={t('claim.search')} />
          </Col>

          <Col xs={1}>
            <Button type="submit">
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Col>
        </Row>
      </Form>
    </Formik>
  );
};

export { ClaimControlForm };
